import type { MenuConfig } from '~typings/menu'

import permisosLogisticaPg, { RESOURCE_LOGISTICA_PG } from '@/auth/permissions/modules/logisticaPg'
import * as names from '@routes/logistica-pg/nombres/configuracion'

const { configuracion } = permisosLogisticaPg
export default [
    {
        title: 'logistica_pg.subopciones.precio_ruta',
        action: configuracion.precioRuta,
        resource: RESOURCE_LOGISTICA_PG,
        route: names.ROUTE_PRECIO_RUTA,
    },
] as MenuConfig[]
